module.exports = __webpack_public_path__ + "static/media/niam.6d4900e5.png";